var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.42,39S377.78,9.62,296.66,56.4s-122,139.66-157.2,214.05-14.92,150.06,47,184.57,104-16.36,190.91-18.84,110.23,9.94,182.32-39.13,85.11-165,28.25-250.73S460.42,39,460.42,39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.42,39S377.78,9.62,296.66,56.4s-122,139.66-157.2,214.05-14.92,150.06,47,184.57,104-16.36,190.91-18.84,110.23,9.94,182.32-39.13,85.11-165,28.25-250.73S460.42,39,460.42,39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.14,225.69c3.29-.78,9.25-5.47,9.26-5.47s-4.29-3-4.58-3.15c-3.42-1.78-11.08-3.21-14.15-.18a5.1,5.1,0,0,0,.57,7.58C221.59,226.42,225.34,226.35,228.14,225.69Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.43,241.67c2.85-1.56,7.08-7.19,7.41-7.64a89.67,89.67,0,0,0,10.1,6.61c2,1.17,4.13,2.28,6.24,3.36-1-.35-2-.66-2.1-.69-3.77-.81-11.53-.17-13.7,3.56a5.11,5.11,0,0,0,2.55,7.17c2.78,1.25,6.39.2,8.92-1.18s6.26-6.13,7.23-7.4l2.43,1.23c3.91,1.94,7.82,3.86,11.6,5.86,1.33.71,2.61,1.45,3.9,2.19-.92-.31-1.7-.57-1.82-.59-3.77-.82-11.53-.18-13.69,3.56a5.1,5.1,0,0,0,2.55,7.16c2.78,1.26,6.38.2,8.91-1.18s5.9-5.67,7.06-7.17c1.29.8,2.59,1.59,3.81,2.43.82.58,1.66,1.09,2.45,1.72l2.36,1.82c1.47,1.21,3,2.45,4.38,3.66,1,.84,1.89,1.66,2.82,2.48-1.32-.72-3.93-2.07-4.16-2.16-3.6-1.38-11.37-1.92-14.07,1.45a5.11,5.11,0,0,0,1.43,7.47c2.56,1.66,6.28,1.16,9,.18,3-1.08,7.84-5.79,8.44-6.39,1.53,1.37,3,2.7,4.37,4,3.69,3.45,6.79,6.55,9.22,9.06l2.3-1.72c-2.55-2.53-5.84-5.7-9.79-9.23-1.54-1.39-3.22-2.84-5-4.32a55.12,55.12,0,0,0,3.05-5.76c3.21.58,9.42-.58,10.22-.74.52,2,1,3.91,1.44,5.74,1.14,4.77,2,9,2.64,12.35l2.5-1.88c-.69-3.15-1.55-6.9-2.65-11.09-.53-2-1.12-4.15-1.76-6.34.75-.35,6.88-3.27,8.94-5.69,1.86-2.19,3.63-5.51,3-8.48a5.11,5.11,0,0,0-6.5-4c-4.09,1.36-6.3,8.83-6.26,12.69,0,.23.3,2.69.51,4.25-.27-.9-.51-1.77-.79-2.68-.55-1.82-1.15-3.62-1.79-5.55-.34-.93-.69-1.86-1-2.8s-.79-1.9-1.19-2.85c-1-2.21-2-4.39-3.17-6.57,1.59-.48,7.21-2.28,9.39-4.18s4.43-4.9,4.22-7.94a5.1,5.1,0,0,0-5.82-4.89c-4.26.72-7.57,7.78-8.12,11.59,0,.24-.12,3-.14,4.55-.69-1.3-1.38-2.61-2.12-3.9-2.15-3.74-4.44-7.47-6.71-11.19l-2.06-3.43c.57-.16,7.29-2.15,9.74-4.28,2.18-1.88,4.43-4.89,4.22-7.94a5.11,5.11,0,0,0-5.82-4.89c-4.26.73-7.57,7.78-8.12,11.59,0,.29-.16,4.3-.14,5.32-1.51-2.52-3-5-4.34-7.59a89.52,89.52,0,0,1-4.86-10.61c.26-.08,7.29-2.13,9.8-4.3,2.17-1.89,4.42-4.9,4.22-7.94a5.12,5.12,0,0,0-5.83-4.89c-4.26.72-7.57,7.77-8.12,11.59,0,.3-.17,4.61-.13,5.39-.08-.21-.19-.42-.27-.64a66.18,66.18,0,0,1-2.87-11.34c-.37-2.12-.6-4.18-.78-6.18,1.35-.25,7.49-1.45,10-3.15s4.93-4.38,5.06-7.43a5.11,5.11,0,0,0-5.25-5.5c-4.31.25-8.37,6.89-9.34,10.63-.05.2-.36,2.32-.56,3.87-.07-.9-.16-1.84-.21-2.7-.19-3.26-.16-6.26-.11-8.92,0-1.51.1-2.87.17-4.14,1.2-.94,6-4.76,7.35-7.36s2.37-6.17,1.08-8.93a5.11,5.11,0,0,0-7.2-2.46c-3.71,2.21-4.25,10-3.39,13.74.07.32,1.82,5.27,1.88,5.22l.08-.06c-.1,1.23-.19,2.54-.25,4-.11,2.66-.2,5.67-.08,8.94a91,91,0,0,0,.89,10.56,67.19,67.19,0,0,0,2.66,11.55.69.69,0,0,0,.05.13c-.74-1-2.91-3.82-3.11-4-2.69-2.76-9.52-6.5-13.38-4.58a5.11,5.11,0,0,0-1.83,7.38c1.63,2.58,5.22,3.69,8.09,3.93,3.23.28,9.87-2.09,10.4-2.28A90.37,90.37,0,0,0,298.81,211c1.06,2.09,2.19,4.17,3.35,6.24-.67-.87-1.27-1.63-1.37-1.73-2.69-2.76-9.52-6.51-13.39-4.59a5.12,5.12,0,0,0-1.82,7.39c1.62,2.57,5.21,3.68,8.08,3.93s8.61-1.66,10.11-2.18c.46.79.9,1.58,1.36,2.37,2.19,3.77,4.39,7.53,6.43,11.28.73,1.33,1.39,2.65,2.06,4-.6-.77-1.11-1.41-1.2-1.5-2.69-2.76-9.52-6.51-13.38-4.58a5.11,5.11,0,0,0-1.83,7.38c1.63,2.58,5.22,3.69,8.09,3.93s8.05-1.47,9.84-2.09c.64,1.38,1.28,2.76,1.85,4.13.36.94.77,1.82,1.08,2.79l1,2.82c.56,1.81,1.14,3.68,1.63,5.47.36,1.24.67,2.42,1,3.62-.7-1.33-2.14-3.89-2.28-4.09a19.74,19.74,0,0,0-7.93-6.12,5.45,5.45,0,0,0-.73-.86,5.11,5.11,0,0,0-7.6.29c-2.67,3.39-.39,10.84,1.77,14,.13.18,1.73,2.08,2.77,3.25-.71-.6-1.4-1.19-2.14-1.79-1.46-1.22-2.95-2.38-4.55-3.65L298.56,259c-.79-.61-1.7-1.15-2.56-1.73-2-1.31-4.12-2.53-6.27-3.72,1.06-1.28,4.75-5.88,5.53-8.67s1-6.52-.86-9a5.12,5.12,0,0,0-7.56-.87c-3.15,3-2,10.66-.37,14.15.1.22,1.56,2.59,2.39,3.87-1.3-.7-2.59-1.41-3.92-2.08-3.86-1.94-7.82-3.78-11.77-5.63l-3.61-1.73c.39-.45,4.9-5.82,5.77-8.94.77-2.78,1-6.53-.86-8.95a5.12,5.12,0,0,0-7.56-.87c-3.15,2.95-2,10.66-.38,14.15.13.26,2.24,3.67,2.81,4.51-2.64-1.27-5.26-2.56-7.8-3.93a90.61,90.61,0,0,1-9.91-6.18c.18-.21,4.91-5.79,5.8-9,.78-2.77,1-6.52-.86-9a5.1,5.1,0,0,0-7.55-.86c-3.16,2.95-2,10.65-.38,14.14.13.28,2.4,3.94,2.86,4.57-.18-.13-.39-.25-.57-.38a65.37,65.37,0,0,1-8.65-7.88c-1.48-1.57-2.81-3.15-4.07-4.72,1-.95,5.46-5.34,6.58-8.13s1.7-6.38.13-9a5.12,5.12,0,0,0-7.42-1.69c-3.46,2.59-3.18,10.37-1.93,14,.07.2,1,2.14,1.67,3.54-.55-.72-1.14-1.45-1.66-2.14-2-2.62-3.59-5.13-5-7.37-.8-1.28-1.5-2.45-2.15-3.56.49-1.44,2.36-7.26,2.08-10.19s-1.43-6.45-4-8a5.11,5.11,0,0,0-7.36,1.92c-1.88,3.89,1.95,10.67,4.75,13.33.24.23,4.42,3.39,4.45,3.31l0-.08c.6,1.07,1.25,2.22,2,3.45,1.38,2.28,3,4.84,4.87,7.5a92,92,0,0,0,6.56,8.32,67.09,67.09,0,0,0,8.59,8.16l.11.08c-1.18-.44-4.53-1.58-4.8-1.63-3.77-.82-11.53-.18-13.7,3.56a5.11,5.11,0,0,0,2.55,7.16C237.29,244.11,240.9,243.05,243.43,241.67Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.44,181c.08,0-1.92-4.85-2.08-5.15-1.87-3.37-7.47-8.79-11.7-7.95A5.1,5.1,0,0,0,273,174.5c.88,2.91,4.05,4.93,6.76,5.92C282.88,181.59,290.44,181,290.44,181Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.74,71.26H441.85l-3,5.47a18.39,18.39,0,0,1-32.16,0l-2.95-5.47H332.9A13.52,13.52,0,0,0,319.21,84.6V449.66A13.52,13.52,0,0,0,332.9,463H512.74a13.53,13.53,0,0,0,13.7-13.34V84.6A13.53,13.53,0,0,0,512.74,71.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.89,
    y: 76.51,
    width: 14.29,
    height: 7.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9107233255922075px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.89,
    y: 76.51,
    width: 11.15,
    height: 7.84,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8042472707551498px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.15,
    y: 78.7,
    width: 2.01,
    height: 3.45,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8042472707551498px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.01,
    y: 78.94,
    width: 2.62,
    height: 4.49,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795144838410508px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.13,
    y: 77.36,
    width: 2.62,
    height: 6.07,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795144838410508px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.25,
    y: 75.5,
    width: 2.62,
    height: 7.93,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795144838410508px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.55,
    y1: 87.03,
    x2: 520.06,
    y2: 87.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.53,196.73a1.45,1.45,0,0,0,1.45-1.45V156.36a1.45,1.45,0,0,0-1.45-1.45h-3.78V80.56a18.68,18.68,0,0,0-18.69-18.68H331.58a18.68,18.68,0,0,0-18.69,18.68V464.22a18.68,18.68,0,0,0,18.69,18.68H514.06a18.68,18.68,0,0,0,18.69-18.68v-234h3.78a1.45,1.45,0,0,0,1.45-1.45V211.42a1.45,1.45,0,0,0-1.45-1.45h-3.78V196.73ZM526.44,449.66A13.53,13.53,0,0,1,512.74,463H332.9a13.52,13.52,0,0,1-13.69-13.34V84.6A13.52,13.52,0,0,1,332.9,71.26h70.89l2.95,5.47a18.39,18.39,0,0,0,32.16,0l3-5.47h70.89a13.53,13.53,0,0,1,13.7,13.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.7,73.35a4.88,4.88,0,1,0-4.88,4.88A4.87,4.87,0,0,0,427.7,73.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-balloons--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.46,98.09h-110a8.39,8.39,0,0,0-8.39,8.39v45.07L339.94,141H448.46a8.39,8.39,0,0,0,8.39-8.39V106.48A8.39,8.39,0,0,0,448.46,98.09Z",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.48,
    cy: 116.54,
    r: 11.79,
    transform: "translate(-14.15 58.16) rotate(-9.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.43,116.8s1.24-1.65,1.52,0-2.12,3.72-2.12,3.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,116.8s-1.23-1.65-1.51,0,2.11,3.72,2.11,3.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.92,108.67s-4.67-.36-5.75,2.75-.35,8.14,0,9.1,3.36,5.62,4.19,6,2.88.24,3.23-.24,3.36-4.91,3.59-6.46a55.55,55.55,0,0,0-.13-6.86,4.28,4.28,0,0,0-2.63-3.72A7.65,7.65,0,0,0,352.92,108.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.05,112.94a4.28,4.28,0,0,0-2.63-3.72,7.65,7.65,0,0,0-2.5-.55s-4.67-.36-5.75,2.75a15.17,15.17,0,0,0-.53,5.46c.24.28,1,1.11.9.06-.14-1.24-.28-5,.69-5.78s1.1-1.51,2.47-.41,1.24,2.06,2.62,1.38,1.65-2.2,2.88-1.65.83,3.16.83,4.4,0,3.57.83,2.47a3.18,3.18,0,0,0,.36-.74C358.18,115.35,358.11,114,358.05,112.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.93,125.75s1.48-3,2.42-1.88a6.11,6.11,0,0,1,1.24,2.39A2.78,2.78,0,0,1,350.93,125.75Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,108.44a3.34,3.34,0,0,0-1.07-1.35l-.67-.4s1.61-.67,2.14-.13a10.2,10.2,0,0,1,.94,1.07s.27-1.88.94-1.21a13.22,13.22,0,0,0,1.21,1.08s-1.88.53-1.88,1.88",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 108.11,
    x2: 395.67,
    y2: 108.11,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.2183897918006874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 116.62,
    x2: 446.04,
    y2: 116.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 123.66,
    x2: 446.04,
    y2: 123.66,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 131.44,
    x2: 446.04,
    y2: 131.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.84,159H396.78a8.38,8.38,0,0,0-8.38,8.39v26.17a8.39,8.39,0,0,0,8.38,8.39H505.31l9.92,10.51V167.37A8.39,8.39,0,0,0,506.84,159Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.61,
    y1: 168.99,
    x2: 454.05,
    y2: 168.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.2183897918006874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.61,
    y1: 177.51,
    x2: 504.42,
    y2: 177.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.61,
    y1: 184.55,
    x2: 504.42,
    y2: 184.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.61,
    y1: 192.33,
    x2: 504.42,
    y2: 192.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.35,
    cy: 179.89,
    r: 11.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.87,170.93a5.5,5.5,0,0,0-5.57,3.82A36.77,36.77,0,0,0,402,186.27c0,2.44,4.83,4.37,7.47,4.57s8.58.1,10.62-3.15-1.27-9.85-2.09-13.91S412.71,170.73,409.87,170.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.3,179.08s1.24-1.65,1.51,0-2.11,3.71-2.11,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.44,179.08s-1.24-1.65-1.51,0,2.11,3.71,2.11,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,171s-4.67-.36-5.75,2.75-.36,8.14,0,9.09,3.35,5.63,4.19,6,2.87.24,3.23-.24,3.35-4.91,3.59-6.46a55.52,55.52,0,0,0-.13-6.86,4.27,4.27,0,0,0-2.63-3.72A7.65,7.65,0,0,0,411.79,171Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.24,172.15s7.55,6.93,9.06,6.93,1.71-5.1.08-7.54S408,167.68,408.24,172.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.46,221.68h-110a8.39,8.39,0,0,0-8.39,8.38v45.07l9.92-10.51H448.46a8.38,8.38,0,0,0,8.39-8.38V230.06A8.38,8.38,0,0,0,448.46,221.68Z",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.48,
    cy: 240.13,
    r: 11.79,
    transform: "translate(-4.88 472.92) rotate(-67.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.43,240.39s1.24-1.65,1.52,0-2.12,3.71-2.12,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,240.39s-1.23-1.65-1.51,0,2.11,3.71,2.11,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.92,232.25s-4.67-.36-5.75,2.75-.35,8.14,0,9.1,3.36,5.63,4.19,6,2.88.24,3.23-.24,3.36-4.9,3.59-6.46a55.55,55.55,0,0,0-.13-6.86,4.25,4.25,0,0,0-2.63-3.71A7.9,7.9,0,0,0,352.92,232.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.05,236.52a4.25,4.25,0,0,0-2.63-3.71,7.9,7.9,0,0,0-2.5-.56s-4.67-.36-5.75,2.75a15.23,15.23,0,0,0-.53,5.47c.24.27,1,1.11.9.06-.14-1.24-.28-5,.69-5.78s1.1-1.51,2.47-.41,1.24,2.06,2.62,1.37,1.65-2.2,2.88-1.65.83,3.16.83,4.4,0,3.58.83,2.48a3.29,3.29,0,0,0,.36-.75C358.18,238.94,358.11,237.57,358.05,236.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.93,249.33s1.48-3,2.42-1.88a6.18,6.18,0,0,1,1.24,2.39A2.78,2.78,0,0,1,350.93,249.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,232a3.28,3.28,0,0,0-1.07-1.34l-.67-.4s1.61-.67,2.14-.14a10.89,10.89,0,0,1,.94,1.08s.27-1.88.94-1.21a12.1,12.1,0,0,0,1.21,1.07s-1.88.54-1.88,1.88",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 231.69,
    x2: 395.67,
    y2: 231.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.2183897918006874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 240.21,
    x2: 446.04,
    y2: 240.21,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 247.25,
    x2: 446.04,
    y2: 247.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 255.02,
    x2: 446.04,
    y2: 255.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.46,283.21h-110A8.39,8.39,0,0,0,330,291.6v45.07l9.92-10.51H448.46a8.39,8.39,0,0,0,8.39-8.39V291.6A8.38,8.38,0,0,0,448.46,283.21Z",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.48,
    cy: 301.66,
    r: 11.79,
    transform: "translate(-61.67 510.75) rotate(-67.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.43,301.92s1.24-1.65,1.52,0-2.12,3.71-2.12,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,301.92s-1.23-1.65-1.51,0,2.11,3.71,2.11,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.92,293.78s-4.67-.36-5.75,2.76-.35,8.13,0,9.09,3.36,5.63,4.19,6,2.88.24,3.23-.24,3.36-4.91,3.59-6.47a55.57,55.57,0,0,0-.13-6.86,4.25,4.25,0,0,0-2.63-3.71A7.9,7.9,0,0,0,352.92,293.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.05,298.05a4.25,4.25,0,0,0-2.63-3.71,7.9,7.9,0,0,0-2.5-.56s-4.67-.36-5.75,2.76a15.17,15.17,0,0,0-.53,5.46c.24.28,1,1.11.9.06-.14-1.24-.28-4.95.69-5.78s1.1-1.51,2.47-.41,1.24,2.06,2.62,1.37,1.65-2.2,2.88-1.65.83,3.17.83,4.4,0,3.58.83,2.48a3.4,3.4,0,0,0,.36-.74C358.18,300.47,358.11,299.1,358.05,298.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.93,310.86s1.48-2.95,2.42-1.87a6.11,6.11,0,0,1,1.24,2.39A2.79,2.79,0,0,1,350.93,310.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,293.55a3.28,3.28,0,0,0-1.07-1.34l-.67-.4s1.61-.67,2.14-.14a10.89,10.89,0,0,1,.94,1.08s.27-1.88.94-1.21a12.1,12.1,0,0,0,1.21,1.07s-1.88.54-1.88,1.88",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 293.22,
    x2: 395.67,
    y2: 293.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.2183897918006874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 301.74,
    x2: 446.04,
    y2: 301.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 308.78,
    x2: 446.04,
    y2: 308.78,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 316.55,
    x2: 446.04,
    y2: 316.55,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.46,399.16h-110a8.39,8.39,0,0,0-8.39,8.39v45.07l9.92-10.51H448.46a8.38,8.38,0,0,0,8.39-8.39V407.55A8.39,8.39,0,0,0,448.46,399.16Z",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.48,
    cy: 417.61,
    r: 11.79,
    transform: "translate(-62.53 62.08) rotate(-9.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.43,417.88s1.24-1.65,1.52,0-2.12,3.71-2.12,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,417.88s-1.23-1.65-1.51,0,2.11,3.71,2.11,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.92,409.74s-4.67-.36-5.75,2.75-.35,8.14,0,9.1,3.36,5.62,4.19,6,2.88.24,3.23-.24,3.36-4.9,3.59-6.46a55.55,55.55,0,0,0-.13-6.86,4.28,4.28,0,0,0-2.63-3.72A7.91,7.91,0,0,0,352.92,409.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.05,414a4.28,4.28,0,0,0-2.63-3.72,7.91,7.91,0,0,0-2.5-.55s-4.67-.36-5.75,2.75a15.23,15.23,0,0,0-.53,5.47c.24.27,1,1.11.9.05-.14-1.23-.28-4.95.69-5.77s1.1-1.52,2.47-.42,1.24,2.07,2.62,1.38,1.65-2.2,2.88-1.65.83,3.16.83,4.4,0,3.58.83,2.48a3.51,3.51,0,0,0,.36-.75C358.18,416.42,358.11,415.06,358.05,414Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.93,426.82s1.48-2.95,2.42-1.88a6.18,6.18,0,0,1,1.24,2.39A2.78,2.78,0,0,1,350.93,426.82Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,409.51a3.28,3.28,0,0,0-1.07-1.34l-.67-.4s1.61-.68,2.14-.14a11.52,11.52,0,0,1,.94,1.07s.27-1.87.94-1.2a12.1,12.1,0,0,0,1.21,1.07s-1.88.54-1.88,1.88",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 409.18,
    x2: 395.67,
    y2: 409.18,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.2183897918006874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 417.7,
    x2: 446.04,
    y2: 417.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 424.73,
    x2: 446.04,
    y2: 424.73,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.23,
    y1: 432.51,
    x2: 446.04,
    y2: 432.51,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.84,344.6H396.78A8.39,8.39,0,0,0,388.4,353v26.17a8.38,8.38,0,0,0,8.38,8.39H505.31l9.92,10.51V353A8.39,8.39,0,0,0,506.84,344.6Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.61,
    y1: 354.62,
    x2: 454.05,
    y2: 354.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.2183897918006874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.61,
    y1: 363.14,
    x2: 504.42,
    y2: 363.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.61,
    y1: 370.17,
    x2: 504.42,
    y2: 370.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.61,
    y1: 377.95,
    x2: 504.42,
    y2: 377.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.35,
    cy: 365.52,
    r: 11.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.87,356.56a5.5,5.5,0,0,0-5.57,3.82A36.67,36.67,0,0,0,402,371.9c0,2.44,4.83,4.37,7.47,4.57s8.58.1,10.62-3.15-1.27-9.85-2.09-13.92S412.71,356.36,409.87,356.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.3,364.71s1.24-1.65,1.51,0-2.11,3.71-2.11,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.44,364.71s-1.24-1.65-1.51,0,2.11,3.71,2.11,3.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,356.57s-4.67-.36-5.75,2.76-.36,8.13,0,9.09,3.35,5.63,4.19,6,2.87.24,3.23-.24,3.35-4.91,3.59-6.47a55.57,55.57,0,0,0-.13-6.86,4.25,4.25,0,0,0-2.63-3.71A7.9,7.9,0,0,0,411.79,356.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.24,357.78s7.55,6.93,9.06,6.93,1.71-5.1.08-7.54S408,353.31,408.24,357.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535,458.7,533.74,481a3.46,3.46,0,0,0,2.1,1.85c1.35.24,30.78,0,30.78,0a7.64,7.64,0,0,0-.24-3.58,4.67,4.67,0,0,0-3.2-3.2c-1.48-.37-11.7-5.05-12.57-5.42s-1.35-6.28-1.35-6.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.62,482.84a8,8,0,0,0,0-2.39l-32.84-.88-.08,1.42a3.46,3.46,0,0,0,2.1,1.85C537.19,483.08,566.62,482.84,566.62,482.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.11,345.72s2.53,54.72,2.25,56.4l-9.54,57.52s8.13,4.49,12.06,5.33a71.89,71.89,0,0,0,9.26,1.12s12.91-52.47,13.47-55.55S562.15,341,562.15,341Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.5,452.79s-11.45,15.76-10.1,17.36,11.33,11.08,13.8,12.19,25,0,25,0a6.4,6.4,0,0,0,.37-2c0-1-.12-4.8-1.47-5.91s-11.58-5.91-12-6.65-.86-6.77-.86-6.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.19,482.34a6.4,6.4,0,0,0,.37-2v-.46l-15.64.59s-4.8.73-7.38-1.36c-2.17-1.75-11.66-10.4-14.7-13.18-1.15,2.1-1.82,3.73-1.44,4.19,1.36,1.6,11.33,11.08,13.8,12.19S570.19,482.34,570.19,482.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,320.19s1.69,16.27,3.09,18.8,3.65,6.45,3.65,6.45L561,405.21l-21.88,48.26s16,10.38,19.36,11.5a17.65,17.65,0,0,0,4.49,1.12s25.81-60.32,25.81-64.53-18-64.53-18-64.53L572,316.26Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "554.28 325.24 566.08 329.96 556.3 322.2 563.04 325.24",
    style: {
      fill: "none",
      stroke: "#696969",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "547.5 366.24 561.03 405.21 541.39 450.38",
    style: {
      fill: "none",
      stroke: "#696969",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.76,
    y1: 358.35,
    x2: 546.15,
    y2: 362.37,
    style: {
      fill: "none",
      stroke: "#696969",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.3,290s6.64-6.24,8-7,6.77-2.39,7.16-4.25-.13-11-.66-10.61-7.56,10.35-7.56,10.35l-9.16,7.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.73,
    y1: 275.54,
    x2: 595.93,
    y2: 281.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 598.85,
    y1: 272.35,
    x2: 599.12,
    y2: 279.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601,269.83s-.13,7.83,0,8.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.83,276.6s2.26-2.79,1.73-4.64a3.6,3.6,0,0,0-2.13-2.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.51,282.84c.4.26,3.58,5.17,3.58,5.17l-4,5.31s2,3.72.8,4.65-11.15,6.1-11.15,6.1l-3.32-13.4s7.43-4.65,7.83-4.51a4.13,4.13,0,0,1,1.06.79Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.74 281.05 592.12 282 606.74 261.08 605.36 260.12 590.74 281.05",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.14,242.53c-.82.4-12.41,14.44-16.69,19.93s-3.86,14.45-3.66,19.33-2,41.1-2,41.1,17.7-1.42,28.28-2.44,25.63-2,25.63-2-4.27-18.71-6.3-27.06-5.29-20.34-7.53-26a79.53,79.53,0,0,0-5.5-11Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.7,243.14l-6.51,7.32-10-12.61,5.9-6.92s3.46-3.66,5.5-3.26S570.7,243.14,570.7,243.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.79 235.61 567.76 246.68 570.7 243.14 563.79 235.61",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,230.73s-2.44,3.86-4.47,3.05-7.53-6.72-10-14,6.51-8.55,7.93-11.39,2.65-3.26,4.68-13.23,24.82-6.1,28.28-.81,2.85,15.87,12.41,12.41,19.94-7.12,22.18,1.42-5.09,18.92-2.44,22.59,11.19,1,10.58,4.47-5.09,5.7-3.67,6.51,9.36-3.25,7.12.41-6.91,7.53-7.52,5.9,0-3.66-2.24-2.44-9,6.1-11.8,3.46.81-12.21-3.87-13.23-16.07,2.24-19.94,2.44-4.27-1-11.39-4.47S563,230.73,563,230.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.6,225s12,.61,19.73-1.43a73.26,73.26,0,0,0,10.38-3.25s.2,7.93-1.83,10.17-4.68,4.27-4.68,5.9,2,4.27.81,5.7-4.07,1.42-4.88,1.42-7.32,6.11-9.15,6.11-11-12.21-11.19-14a64.32,64.32,0,0,1,0-6.51",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586,232.15l-2.24,2.64a3.78,3.78,0,0,1-3.05-2.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43,238.25s-.2,3.26,2.45,3.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.52,228.69s3.66-1.22,5.29,1.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.65,228.08s-3-9-5.9-5.7-1.22,9,1,10.18a4.52,4.52,0,0,0,4.27,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555,234.59s13.42,13.23,13,15.06-2.65,3-2.65,3,.61,3.66-.4,4.47a5.39,5.39,0,0,1-2.24,1S550,245,548.32,242.93s-.4-3.05.61-3.46a13.38,13.38,0,0,1,2.24-.61S552.6,234,555,234.59Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.57,264.15a94.5,94.5,0,0,0-1.26,14.31c0,7.15,2.94,42.29,4.42,44.19s7.36,3.57,9.89,1.89,24.41-15.78,24.62-18.1-3.37-10.73-4.84-11.36-2.74-.42-4.84,1.47A63.72,63.72,0,0,1,556,301.6s-1.47-26.93-3.15-33.46-2.53-7.78-3.58-8.2",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.37,291.35s6-14.37,6.44-15.42,1.9-2.74,3.16-2.95,10.94-2.31,11.78-2.52,1.48.84-.84,2.31-8,2.11-8,2.11l-.85,6.31s5.69-4.42,5.69-2.1-4.21,3.78-4.84,4S584.6,286,584,286.45a17.21,17.21,0,0,1-3,1.05s-.42,2.53-1.26,3.37-4.63,3.58-4.63,3.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.81,275.93s2.44-3,2.8-3a52.31,52.31,0,0,1,4.93,3.95c.3.29-1.58,3.35-1.87,3.84s-.4.89-1.19.6a5.8,5.8,0,0,1-1.48-.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.16,278.38s2.66-3,3.05-3,3.75,2.66,3.75,3.15-.59,3.46-1.08,3.56a10.26,10.26,0,0,1-2.07-.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.06,281.24a14.05,14.05,0,0,1,2.37-2.07c.78-.4,2.56,1.28,3.64,2s2.37,1.13,1.78,1.82-2.86-.29-3.35-.29a5.82,5.82,0,0,1-1.58-.5l-1.28,3.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.35,295.71l7.36-5.89,3.37,6.31-6.32,6.52S567.35,301.81,567.35,295.71Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133,469.05a26.35,26.35,0,0,1-8.33-4.38C121.34,461.8,110.82,454,107.78,452s-2.67,7.24-1.64,12a28,28,0,0,0,5.11,11.33c1.92,2.28,14.45,7,15.85,7.32s7,.42,8.14-.12S134,473,133,469.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.89,471.44c-2.93-3.76-5-15.29-5.09-19.71-2,.47-1.56,8.1-.66,12.3a28,28,0,0,0,5.11,11.33c1.92,2.28,14.45,7,15.85,7.32a30.9,30.9,0,0,0,5.71.22C126,480.51,114.84,475.22,111.89,471.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.7,400.53s-3.46,6.41-5.21,10.13-3.25,6.4-3.25,6.4-1.67-3.26-2.94-2.65a14.05,14.05,0,0,1-2.76.91s-1.58-5.66-4-8.63-4.47-1.54-6.71-3.52c-3.17-2.8-4.45-3.64-6.57-5.34-2.61-2.09-6.6,6.76-6.67,10.1S248.63,432.26,252.9,438s8.58,9.35,11.36,5.86,4.1-6.81,6.2-18S277.69,397.56,269.7,400.53Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.24,397.83,230.47,392c-.84-1.65-2.53-5.08-3.45-7.47-1.26-3.25-1.81-5.32-4.7-7.58s-9.73-5-10.6-5.93-1.22,2.62.36,4.27a7.33,7.33,0,0,0,2.6,2s-11.27-1.4-11.29-.52,9.58,13,13.05,15.81c1.45,1.2,4.69,2.33,6.53,3.65a16.16,16.16,0,0,1,2.5,2.22c-.43.24-.57.23-.62.2.4.56,6.37,9.08,8.2,8.71S241,406.44,238.24,397.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.18,
    y: 361.33,
    width: 1.47,
    height: 27.73,
    transform: "translate(-174.63 183.84) rotate(-34.26)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,370.65s-6,6.48-5.28,7.08,3,2.85,3.62,2.57,3.78-5.5,3.94-6.09S206.89,370.65,206.89,370.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89,375s-4.54,6.66-4.11,7.26,6.17,7.31,6.89,7.76,4.77-3.43,4.77-3.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.31,378.82s-4.24,6.67-3.8,6.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.15,
    y1: 383.43,
    x2: 211.24,
    y2: 388.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.68,377.26l3.64,1.68s-.91,8.94,4,12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.85,398.62l0,0S224.83,398.6,224.85,398.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.43,447.25S231.05,405,227.21,400.46s-12.5-6.42-17.58-4.84-11.26,15.78-12.49,21.65-11.28,31.21-13,34.54-4.34,6.93-4.37,8.34-.05,2.52-.05,2.52l-1.76,3.89s8.12,1,11.5.51,8.22-4.33,9.1-6.28,3.36-6.75,6.35-8.85c4.26-3,11.67-23.07,11.67-23.07l14,30.59s27.7,3.91,33.89,3.19S266.43,447.25,266.43,447.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.09,443.86s-4.32,5.52-4.34,6.65l0,1.12L237.11,454s-24.41-.48-28.07.29-56.7,14.89-60.08,15.39-5-2.35-6.4-2.38-2.79-1.18-4.75-1.22-3.7,2.74-4.83,3a8.8,8.8,0,0,1-2.26.51c-.84,0-.24-2-.84,0s-2.11,7.53-.76,10.08a11.91,11.91,0,0,0,3.57,4s45.47.05,53,.2,30.91-1.91,33.72-2.14,43.45,2.25,49.9,2.38,27.79,0,31.48-2.19,8.42-14.43,7.67-19.21-39.77-18.46-39.77-18.46Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.48,439.9a5.63,5.63,0,0,0-.34,3.08c.24,2,44.17,23,45.59,22.22s2.42-8.94,2.42-8.94l-47.62-18.89Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.2,372.63s-8.07,11.07-11.05,19.71-7.77,38.29-9.52,41.91-1.8,5.86.71,6.47,26.45,11.18,34.52,14.42,15.31,6.2,16.53,1.17,1.29-8.11,1.15-15.69-.27-43.23-.91-53.62-6.2-27.35-13.5-26.93S282.2,372.63,282.2,372.63Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,333.67c-.86-6.1-3.78-11.08-8.77-14.2a5.12,5.12,0,0,1,6.41-1s.67-2.38-1.27-3.21a3.64,3.64,0,0,0-3.47.46s.33-3.19,2.49-4.74,6.37.66,6.37.66-.9-8.27-6.25-6.78-4.64,6-4.64,6-1-3.74-4.18-4.07-5.63,2.28-5.63,2.28,2.71-2.34,5.56,1.71a7.38,7.38,0,0,1,1.14,6.94,24.55,24.55,0,0,0-2.59-.85c-7.52-2-16.1.16-19.76,3.82a21.77,21.77,0,0,0-8.06,3.88c-4,3.39-.26,8.07.29,8.71l.3,1.68a97.75,97.75,0,0,0,1.67,10.14c.75,2.41,2.06,3.23,2,4.56s-2.25,6.08-.69,7.7,2.91,1.13,2.91,1.13,6.13,12.89,8.81,11.87,7.29-5.71,7.29-5.71l6.05,3.85,11.15-12.29-2-5.36S298.66,341.94,297.49,333.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.1,333.09c3.24-1.54,11.53-3.44,10.11-.95s-1.74,6.85.08,7.34,5.68,3.09,7,4,3,.29,3-1.09,1.46-4.1,4.41-2.67,3.13,4.19,2.38,7.39a7.3,7.3,0,0,1-3.07,4.52s3.52,2.83,8.94.12l-.35-.92s6-8.93,4.86-17.2c-.86-6.1-3.78-11.08-8.77-14.2a5.12,5.12,0,0,1,6.41-1s.67-2.38-1.27-3.21a3.64,3.64,0,0,0-3.47.46s.33-3.19,2.49-4.74,6.37.66,6.37.66-.9-8.27-6.25-6.78-4.64,6-4.64,6-1-3.74-4.18-4.07-5.63,2.28-5.63,2.28,2.71-2.34,5.56,1.71a7.38,7.38,0,0,1,1.14,6.94,24.55,24.55,0,0,0-2.59-.85c-7.52-2-16.1.16-19.76,3.82a21.77,21.77,0,0,0-8.06,3.88c-4,3.39-.26,8.07.29,8.71C255.13,333.3,256.86,334.63,260.1,333.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.62,345.06l-.06,3a6.45,6.45,0,0,0,5.76-1.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,342.25a5.24,5.24,0,0,1,6.68-1.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.1,358.87s3.9-.15,6.28-4.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11,364.05c-2.32,1.1-5.24-1.94-6.61-2.19-1.11-.21-.92,2-.8,2.86,1.88,3.14,4.11,6.18,5.47,5.66,2.68-1,7.29-5.71,7.29-5.71l.21.14a8.42,8.42,0,0,0,1.14-3.38C278.84,359.6,274.42,363,272.11,364.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.43,353.46s-8.37-2.69-13.24,2.55-18.09,20.69-15.28,20.75,7.73-7.71,13.39-10.13,9-2.34,10.91,1.62,8.41,29.35,11,24.91,7.27-13.32,4.91-21.79S309.2,355.2,306.43,353.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,383.63s-7,12.21-7.67,18.93-2.92,34.75-2.92,34.75-2.77-1.74-4.21-.09-2.35,5.29-2.35,5.29-3.9-1.2-4.78.47a20,20,0,0,1-1.74,2.77L237.11,454s38.4,2.16,41.49,1.94a8.83,8.83,0,0,0,5.1-2.15s2.48,2,6.72.41,5.69-3.53,6.87-6.88,6.76-44.2,6.76-44.2",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.11,454s11.67.66,22.66,1.21c-1.59-2.59-.85-6.33,0-8.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 99,
    y1: 482.9,
    x2: 619.29,
    y2: 482.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1091948959003437px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.fab3ec87d0934fe04a3acef36d8fb37e.svg";
export { ForwardRef as ReactComponent };